<template>
	<b-row class="mb-3">
		<b-col>
			<b-button variant="link" class="text-danger" @click="goBack()">
				<i class="fa fa-hand-o-left" aria-hidden="true"></i> Regresar
			</b-button>
		</b-col>
	</b-row>
</template>

<script>
	export default {
		name: "GoBackComponent",
		methods: {
			goBack() {
				this.$router.go(-1);
			},
		}
	}
</script>

<style scoped>

</style>
